var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconClose48Line = function SvgIconClose48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.2 13.2-2.4-2.4L24 21.6 13.2 10.8l-2.4 2.4L21.59 24 10.8 34.8l2.4 2.4L24 26.4l10.8 10.8 2.4-2.4L26.4 24l10.8-10.8Z",
    fill: "current"
  })));
};
export default SvgIconClose48Line;